/* Las ilustraciones a las que lleva un botón, ya cargadas cuando se pulsa.

   Todas las imágenes de la portada menos la del hero son `loading="lazy"`, que
   es lo correcto: al abrir, el navegador no se gasta la conexión en cinco
   pantallas que nadie ha visto todavía. El problema aparece cuando un botón
   **salta** hasta una de ellas: «Quiero enterarme» cruza la portada entera y la
   lámina del sobre empieza a descargarse justo al llegar, así que se ve medio
   segundo de hueco. Es el fallo que contaba Iker.

   La solución no es quitar la carga perezosa —eso empeora la apertura para
   todo el mundo, que es lo que de verdad se mide—, sino adelantarla solo donde
   hace falta y cuando no estorba:

   1. **Al apuntar al botón.** Basta con acercar el ratón, tocarlo o llegar con
      el tabulador: entre ese gesto y el clic hay tiempo de sobra para una
      imagen de 38 KB.
   2. **Si no, cuando la página ya ha terminado de cargar** y el navegador está
      ocioso (`requestIdleCallback`). Nunca antes: primero cargan el hero y la
      hoja de estilo, que es lo que se ve.

   Se piden con `fetchpriority="low"`, o sea, por detrás de cualquier cosa que
   el navegador necesite de verdad, y **no se pide nada con el ahorro de datos
   puesto ni en una conexión lenta**: ahí la carga perezosa se queda como está y
   quien pulse esperará su medio segundo, que es el trato correcto con esa
   conexión.

   Solo se calientan las secciones a las que apunta un botón de la portada (los
   `data-aru-cta`), no las seis: el resto llegan solas al bajar, y adelantarlas
   sería descargarle a la gente la página entera sin que la haya pedido. */
(function () {
  var TOPE = 6;   // imágenes como mucho, por si algún día crece una sección

  var conexion = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var tacaña = !!conexion && (conexion.saveData === true ||
    /(^|-)(2g|slow-2g)$/.test(conexion.effectiveType || ''));

  var botones = Array.prototype.slice.call(document.querySelectorAll('a[data-aru-cta][href*="#"]'));
  if (!botones.length) return;

  var pendientes = [];   // [{ boton, seccion }]
  botones.forEach(function (boton) {
    var destino = boton.hash;
    if (!destino || destino === '#') return;
    if (boton.pathname !== window.location.pathname || boton.host !== window.location.host) return;
    var seccion;
    try { seccion = document.querySelector(destino); } catch (e) { return; }
    if (seccion) pendientes.push({ boton: boton, seccion: seccion });
  });
  if (!pendientes.length) return;

  function calentar(seccion) {
    var imagenes = seccion.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imagenes.length && i < TOPE; i++) {
      var img = imagenes[i];
      if (img.dataset.aruCalentada) continue;
      img.dataset.aruCalentada = '1';
      /* El orden importa: la prioridad se lee al lanzar la petición, y quitar
         la carga perezosa es lo que la lanza. */
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      img.loading = 'eager';
    }
  }

  function calentarTodas() {
    pendientes.forEach(function (par) { calentar(par.seccion); });
  }

  pendientes.forEach(function (par) {
    function alApuntar() { calentar(par.seccion); }
    par.boton.addEventListener('pointerenter', alApuntar, { once: true, passive: true });
    par.boton.addEventListener('touchstart', alApuntar, { once: true, passive: true });
    par.boton.addEventListener('focus', alApuntar, { once: true });
  });

  if (tacaña) return;

  function enReposo() {
    if (window.requestIdleCallback) window.requestIdleCallback(calentarTodas, { timeout: 2500 });
    else window.setTimeout(calentarTodas, 1200);
  }

  if (document.readyState === 'complete') enReposo();
  else window.addEventListener('load', enReposo, { once: true });
})();
